import { JetView } from 'webix-jet';

/**
 * Class representing the details view for withdrawal requests.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the withdrawal request details view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'), // Placeholder text
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: screen.width > 500 && screen.height > 500 ? true : false, // Disable based on screen size
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Label for type
                    labelPosition: 'top',
                    placeholder: _('Tipo'), // Placeholder for type
                    disabled: screen.width > 500 && screen.height > 500 ? true : false, // Disable based on screen size
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon for date
                    labelPosition: 'top',
                    placeholder: _('Fecha'), // Placeholder for date
                    disabled: screen.width > 500 && screen.height > 500 ? true : false, // Disable based on screen size
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'), // Label for amount
                    labelPosition: 'top',
                    placeholder: _('Monto'), // Placeholder for amount
                    disabled: screen.width > 500 && screen.height > 500 ? true : false, // Disable based on screen size
                    id: 'Monto', // ID for amount field
                },
            ],
        };

        // Secondary information form configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'), // Label for payment system name
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'), // Placeholder for payment system name
                    disabled: true, // Disabled field
                },
            ],
        };

        // Left section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains main information
        };

        // Right section configuration
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info], // Contains secondary information
        };

        // Upper section layout with multiview
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };

        // Narrow upper section layout
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info], // Only main information
        };

        // Window configuration for details withdrawal
        const detailsWithdrawal = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsWithdrawal',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                rows: [upper_section_narrow], // Form body with narrow upper section
            },
        });

        // Return the main form configuration
        return {
            view: 'form',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Use upper section for larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
